// extracted by mini-css-extract-plugin
module.exports = {"container":"TxInfoView_container__K5xXx"};